import { useEffect } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import PercheAffidarsi from "@/components/site/PercheAffidarsi";
import Marquee from "@/components/site/Marquee";
import ChiSono from "@/components/site/ChiSono";
import PatologieTrattate from "@/components/site/PatologieTrattate";
import SecondaOpinione from "@/components/site/SecondaOpinione";
import RicercaInnovazione from "@/components/site/RicercaInnovazione";
import Sedi from "@/components/site/Sedi";
import Prenotazione from "@/components/site/Prenotazione";
import EducazionePaziente from "@/components/site/EducazionePaziente";
import FAQ from "@/components/site/FAQ";
import Contatti from "@/components/site/Contatti";
import Footer from "@/components/site/Footer";

export default function Home() {
  useEffect(() => {
    document.title = "Gotti Manuel Ematologo Pavia Voghera Milano | Dott. Manuel Gotti";
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F8F6] text-[#1A1D1A]" data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <PercheAffidarsi />
        <Marquee />
        <ChiSono />
        <PatologieTrattate />
        <SecondaOpinione />
        <RicercaInnovazione />
        <Sedi />
        <Prenotazione />
        <EducazionePaziente />
        <FAQ />
        <Contatti />
      </main>
      <Footer />
    </div>
  );
}
